import Application from "../../Application";
import { IFormSection } from "../../model/form/FormSection";
import { IFormVersion } from "../../model/form/FormVersion";
import { IFormTypeItem } from "../../model/report/FormTypeItem";
import { IFormVersionItem } from "../../model/report/FormVersionItem";
import { IReport1Applicant } from "../../model/report/Report1Applicant";
import { IFormSectionPresentationModel } from "../../presenter/form/model/FormSectionPresentationModel";
import PortalFormDetailsPresenter, {
  IPortalFormDetailsPresenter
} from "../../presenter/portal/PortalFormDetailsPresenter";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IFormService } from "../../service/form/FormService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowPortalFormDetailsInteractor {
  private application: Application;
  private output?: IPortalFormDetailsPresenter;
  private formService: IFormService;
  private notificationService: INotificationService;
  private credentialsService: ICredentialsService;

  constructor(
    application,
    formService,
    notificationService,
    credentialsService
  ) {
    this.application = application;
    this.formService = formService;
    this.notificationService = notificationService;
    this.credentialsService = credentialsService;
  }

  async getPortalFormDetails(formId: any) {
    let currentLanguage = Number(await this.credentialsService.getLanguage());
    if (!currentLanguage) {
      currentLanguage = this.application.container.resolve<number>("language");
    }

    const formSections = await this.formService.getPortalFormDetails(
      formId,
      currentLanguage
    );
    return formSections;
  }
  async hasPdfAccess() {
    const hasPdfAccess = await this.formService.hasPdfAccess();
    return hasPdfAccess;
  }

  async getPortalForm(formId: number) {
    try {
      const formDetails: {
        formVersion: IFormVersion;
        formSections: IFormSection[];
      } = await this.getPortalFormDetails(formId);
      const hasPdfAccess = await this.hasPdfAccess();
      return {
        formVersion: formDetails.formVersion,
        formSections: formDetails.formSections,
        hasPdfAccess
      };
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute(formVersionId: number) {
    this.output = PortalFormDetailsPresenter({
      application: this.application,
      initialState: {
        formSections: [],
        formVersionId,
        pdfReportVisbile: false,
        hasPdfAccess: false,
        pdfReportData: [] as IFormSectionPresentationModel[],
        formVersion: {} as IFormVersionItem,
        applicant: {} as IReport1Applicant,
        selectedVersion: {} as IFormVersion,
        formType: {} as IFormTypeItem
      }
    });

    this.getPortalForm(formVersionId).then(
      (result) =>
        result &&
        this.output &&
        this.output.setForm(
          result.formVersion,
          result.formSections || ([] as IFormSection[]),
          result.hasPdfAccess || false
        )
    );

    return this.output;
  }
}
